import ModelData from "../../../public/model_data";


const {ccclass, property} = cc._decorator;

@ccclass('PlayerIconVo')
class PlayerIconVo
{
    @property(cc.String)
    iconKey: string = "";
    @property(cc.SpriteFrame)
    iconRes: cc.SpriteFrame = null;
}

@ccclass
export default class IconHolder extends cc.Component {

    @property(PlayerIconVo)
    playerIconArray: PlayerIconVo[] = [];

    onLoad()
    {
        this.initPlayerIconMap();
    }

    initPlayerIconMap()
    {
        let playerIconDic:{[key:string]:any} = {};
        for(let i=0,len=this.playerIconArray.length; i < len; i++)
        {
            let key = this.playerIconArray[i].iconKey;
            playerIconDic[key] = this.playerIconArray[i]
        }
        ModelData.instance.cacheIconConfig(playerIconDic)
    }
}
